import React from 'react'
import img from '../img/error_offers.png';
import imgWebp from '../img/error_offers.webp';
import { Link } from 'react-router-dom';

function ErrorIndicator(props) {
  const { title, text, btn, url } = props;

  return (
    <>
      <picture>
        <source srcSet={imgWebp} type="image/webp" />
        <img src={img} alt="error" />
      </picture>

      <div>
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
      {url &&
        (<div className="btn-block">
          <Link to={props.locale === 'ua' ? `/uk/kasko${url}` : `/kasko${url}`} className="btn btn-bg">{btn}</Link>
        </div>
        )}
    </>
  )
}

export default ErrorIndicator;
